import { DollarSign, Calculator, AlertTriangle } from "lucide-react";

interface Props {
  expectedCash?: number
  countedCash?: number
  difference?: number
}

const CashClosureFooter: React.FC<Props> = ({
  expectedCash,
  countedCash,
  difference
}) => {

  const format = (value?: number) =>
    (value ?? 0).toFixed(2)

  const diffColor =
    difference === 0
      ? "text-[#3CA745]"   // Success
      : difference! > 0
      ? "text-[#F9C107]"   // Warning
      : "text-[#DC3545]"   // Danger

  return (

    <div className="border-t border-stroke px-6 py-4 space-y-4 dark:border-strokedark">

      {/* EXPECTED */}
      <div className="flex items-center justify-between">

        <span className="flex items-center gap-2 text-gray-500 text-sm">

          <DollarSign
            size={16}
            className="text-primary"
          />

          Efectivo esperado

        </span>

        <span className="font-medium text-black dark:text-white">
          ${format(expectedCash)}
        </span>

      </div>


      {/* COUNTED */}
      <div className="flex items-center justify-between">

        <span className="flex items-center gap-2 text-gray-500 text-sm">

          <Calculator
            size={16}
            className="text-[#3BA2B8]"
          />

          Efectivo contado

        </span>

        <span className="font-medium text-black dark:text-white">
          ${format(countedCash)}
        </span>

      </div>


      {/* DIFFERENCE */}
      <div className="flex items-center justify-between">

        <span className="flex items-center gap-2 text-gray-500 text-sm">

          <AlertTriangle
            size={16}
            className={diffColor}
          />

          Diferencia

        </span>

        <span className={`text-lg font-semibold ${diffColor}`}>
          ${format(difference)}
        </span>

      </div>

    </div>

  )

}

export default CashClosureFooter;